<div class="popup-notification" [ngClass]="status" *ngIf="message">
  {{ message | translate:lang }}
</div>
